"use client";

import React from "react";
import { LocaleLink as Link } from "@/components/shared/LocaleLink";
import { useTranslations } from "@/lib/i18n-client";
import { Reveal } from "@/components/shared/motion";
import { Heart, MessageCircle } from "lucide-react";

/**
 * WanderLite support reassurance — a warm "New to eSIMs? We've got you" card
 * for nervous first-timers. Rounded-full pill to the shared /contact-us/ page.
 */
export default function SupportReassure() {
  const { t } = useTranslations();

  return (
    <section className="container mx-auto px-4 py-10">
      <Reveal as="div" className="wander-card flex flex-col items-center gap-4 p-8 text-center sm:p-10" y={18}>
        <span className="wander-chip inline-flex h-14 w-14 items-center justify-center">
          <Heart className="h-6 w-6" />
        </span>
        <h2 className="text-2xl font-extrabold text-foreground sm:text-3xl">
          {t("wander.support.title", "New to eSIMs? We've got you.")}
        </h2>
        <p className="max-w-xl text-muted-foreground">
          {t(
            "wander.support.body",
            "If anything feels confusing, you don't have to figure it out alone. Reach out and a real person will help you get set up.",
          )}
        </p>
        <Link
          href="/contact-us/"
          className="mt-2 inline-flex items-center gap-2 rounded-full bg-primary px-7 py-3 font-semibold text-white shadow-sm transition-all active:scale-[0.98] hover:bg-primary/90"
        >
          <MessageCircle className="h-4 w-4" />
          {t("wander.support.cta", "Talk to support")}
        </Link>
      </Reveal>
    </section>
  );
}
